module.exports = __webpack_public_path__ + "img/outline.f2d7e18c.svg";